module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.event.name.$error
    },
    attrs: {
      "label": "Event name"
    }
  }, [_c('b-form-input', {
    staticClass: "name",
    attrs: {
      "type": "text",
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.$v.event.name.$touch()
      }
    },
    model: {
      value: (_vm.value.name),
      callback: function($$v) {
        _vm.value.name = $$v
      },
      expression: "value.name"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.event.name.hasOwnProperty('required') && !_vm.$v.event.name.required),
      expression: "$v.event.name.hasOwnProperty('required') && !$v.event.name.required"
    }],
    staticClass: "EventFormPartialView__error"
  }, [_vm._v("\n            Event name required\n          ")])], 1), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.event.eventCode.$error
    },
    attrs: {
      "label": "Event code"
    }
  }, [_c('b-form-input', {
    staticClass: "code",
    attrs: {
      "type": "text",
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.$v.event.eventCode.$touch()
      }
    },
    model: {
      value: (_vm.value.eventCode),
      callback: function($$v) {
        _vm.value.eventCode = $$v
      },
      expression: "value.eventCode"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.event.eventCode.hasOwnProperty('required') && !_vm.$v.event.eventCode.required),
      expression: "$v.event.eventCode.hasOwnProperty('required') && !$v.event.eventCode.required"
    }],
    staticClass: "EventFormPartialView__error"
  }, [_vm._v("\n            Event code required\n          ")]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.event.eventCode.hasOwnProperty('unique') && !_vm.$v.event.eventCode.unique),
      expression: "$v.event.eventCode.hasOwnProperty('unique') && !$v.event.eventCode.unique"
    }],
    staticClass: "EventFormPartialView__error"
  }, [_vm._v("\n            Event code is not unique in selected region\n          ")])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Date"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.disableStartAndEndDate || _vm.disabled)),
      expression: "!(disableStartAndEndDate || disabled)"
    }],
    staticClass: "col-6",
    class: {
      'has-danger': _vm.$v.event.startDate.$error
    }
  }, [_c('flatpickr', {
    staticClass: "form-control",
    attrs: {
      "config": Object.assign({}, _vm.fpOptions, {
        altInputClass: 'form-control startDate'
      })
    },
    on: {
      "input": function($event) {
        _vm.$v.event.startDate.$touch()
      }
    },
    model: {
      value: (_vm.value.startDate),
      callback: function($$v) {
        _vm.value.startDate = $$v
      },
      expression: "value.startDate"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.event.startDate.hasOwnProperty('required') && !_vm.$v.event.startDate.required),
      expression: "$v.event.startDate.hasOwnProperty('required') && !$v.event.startDate.required"
    }],
    staticClass: "EventFormPartialView__error"
  }, [_vm._v("\n                Start date required\n              ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disableStartAndEndDate || _vm.disabled),
      expression: "disableStartAndEndDate || disabled"
    }],
    staticClass: "col-6"
  }, [_c('b-form-input', {
    attrs: {
      "disabled": "",
      "value": _vm._f("formatDate")(_vm.value.startDate)
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.disableStartAndEndDate || _vm.disabled)),
      expression: "!(disableStartAndEndDate || disabled)"
    }],
    staticClass: "col-6",
    class: {
      'has-danger': _vm.$v.event.endDate.$error
    }
  }, [_c('flatpickr', {
    staticClass: "form-control",
    attrs: {
      "config": Object.assign({}, _vm.fpOptions, {
        altInputClass: 'form-control endDate'
      })
    },
    on: {
      "input": function($event) {
        _vm.$v.event.endDate.$touch()
      }
    },
    model: {
      value: (_vm.value.endDate),
      callback: function($$v) {
        _vm.value.endDate = $$v
      },
      expression: "value.endDate"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.event.endDate.hasOwnProperty('required') && !_vm.$v.event.endDate.required),
      expression: "$v.event.endDate.hasOwnProperty('required') && !$v.event.endDate.required"
    }],
    staticClass: "EventFormPartialView__error"
  }, [_vm._v("\n                End date required\n              ")]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.event.endDate.hasOwnProperty('greater') && !_vm.$v.event.endDate.greater),
      expression: "$v.event.endDate.hasOwnProperty('greater') && !$v.event.endDate.greater"
    }],
    staticClass: "EventFormPartialView__error"
  }, [_vm._v("\n                End is earlier than start\n              ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disableStartAndEndDate || _vm.disabled),
      expression: "disableStartAndEndDate || disabled"
    }],
    staticClass: "col-6"
  }, [_c('b-form-input', {
    attrs: {
      "disabled": "",
      "value": _vm._f("formatDate")(_vm.value.endDate)
    }
  })], 1)])]), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.event.regionId.$error
    },
    attrs: {
      "label": "Region"
    }
  }, [_c('b-form-select', {
    staticClass: "col-12 regionId",
    attrs: {
      "options": _vm.regionOptions,
      "disabled": _vm.disableRegion || _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.$v.event.regionId.$touch()
      }
    },
    model: {
      value: (_vm.value.regionId),
      callback: function($$v) {
        _vm.value.regionId = $$v
      },
      expression: "value.regionId"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.event.regionId.hasOwnProperty('required') && !_vm.$v.event.regionId.required),
      expression: "$v.event.regionId.hasOwnProperty('required') && !$v.event.regionId.required"
    }],
    staticClass: "EventFormPartialView__error"
  }, [_vm._v("\n            Region required\n          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.event.type.$error
    },
    attrs: {
      "label": "Type"
    }
  }, [_c('b-form-select', {
    staticClass: "col-12 type",
    attrs: {
      "options": _vm.types,
      "disabled": _vm.disableType || _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.$v.event.type.$touch()
      }
    },
    model: {
      value: (_vm.value.type),
      callback: function($$v) {
        _vm.value.type = $$v
      },
      expression: "value.type"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.event.type.hasOwnProperty('required') && !_vm.$v.event.type.required),
      expression: "$v.event.type.hasOwnProperty('required') && !$v.event.type.required"
    }],
    staticClass: "EventFormPartialView__error"
  }, [_vm._v("\n            Type required\n          ")])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Notes"
    }
  }, [_c('b-form-input', {
    staticStyle: {
      "height": "220px"
    },
    attrs: {
      "type": "text",
      "textarea": "",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.value.notes),
      callback: function($$v) {
        _vm.value.notes = $$v
      },
      expression: "value.notes"
    }
  })], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-13e46068"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/EditEvent/EventForm.vue
// module id = 1670
// module chunks = 1